import { Button, Flex, Heading, Link, Text } from "@chakra-ui/react";
import { Table } from "antd";
import { useState, useEffect } from "react";
import { Filter } from "../../components/Filter";
import { SellersModel } from "../../models/Sellers";
import { ColumnsType } from "antd/lib/table";
import { api } from "../../services/Api";
import { Avatar } from "../../components/Avatar";
import WithAuth from "../../hoc/withAuth";
import { clearMask, showToast } from "../../utils";
import { Pagination } from "../../components/Pagination";
import { PlusIcon } from "../../styles/icons/PlusIcon";
import { useNavigate } from "react-router-dom";
import { useSeller } from "../../hooks/useSeller";
import {  isValidCpfOrCnpj } from "../../utils/validationDocument";

const Sellers = () => {
  const [sellers, setSellers] = useState<SellersModel[]>([]);
  const [page, setPage] = useState(1);
  const [totalElements, setTotalElements] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const navigate = useNavigate();
  const { sortSellers } = useSeller();


  async function handleGetInitialData(page: number) {
    setLoading(true);
    try {
      const response = await api.get(`/sellers?page=${page - 1}&size=${pageSize}&${sortSellers}`);
      setSellers(response.data.content);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      setSellers([]);
      error?.response?.data?.errors?.forEach((error: any) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        });
      });
    } finally {
      setLoading(false);
    }
  }
  

  useEffect(() => {
    handleGetInitialData(page)
    //eslint-disable-next-line
  }, [page, pageSize, sortSellers]);

  async function handleSearch(search: string) {

    const params = isValidCpfOrCnpj(search) ? "cnpj":"companyName"
    setLoading(true);
    if (search === "") {
      handleGetInitialData(page);
      return;
    }
    try {
      const response = await api.get(`/sellers?size=${pageSize}&${params}=${params === "cnpj" ? clearMask(search) : search}`);
      setSellers(response.data.content);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      setSellers([]);
      error?.response?.data?.errors?.forEach((error: any) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        });
      });
    } finally {
      setLoading(false);
    }
  }

  const columns: ColumnsType<SellersModel> = [
    {
      key: "companyName",
      title: "Seller",
      render: (text, record) => (
        <Flex w="100%" align="center">
          <Link
            href={`/seller/${record.id}`}

            _hover={{ textDecoration: "none" }}
          >
            <Avatar name={record.companyName ?? record.fantasyName} />
          </Link>
        </Flex>
      ),
    },
    {
      key: "hasAnticipation",
      title: "",
      render: (text, record) => record.activeAnticipation && (
        <Flex justify="end">
          <Flex
            p=".2rem"
            maxW="190px"
            align="center"
            justify="center"
            borderRadius="4px"
            bgColor="rgba(74, 106, 168, 0.15)"
            color="#4A6AA8"
          >
            Cliente com antecipação
          </Flex>
        </Flex>
      )
    }
  ];

  return (
    <Flex 
      w="100%"
      flexDir="column"
      gap="4"
    >
        <Flex
          align="center"
          justifyContent="space-between"
        >
          <Heading
            fontSize="2rem"
          >
            Vendedores
          </Heading>
          <Button
            gap="2"
            variant="secondary"
            onClick={() => navigate("/seller/new")}
          >
            <PlusIcon />
            <Text
              fontWeight={400}
            >
              Novo vendedor
            </Text>
          </Button>
        </Flex>

        <Filter
         placeholder="Buscar vendedores (documento ou nome)"
          needToSubmit
          onSubmitSearch={handleSearch}
          loading={loading}
        />
        <Table<SellersModel>
          columns={columns}
          dataSource={sellers}
          rowKey={(record) => record.id}
          pagination={false}
          locale={{ emptyText: "Sem vendedores cadastrados" }}
        />
        <Pagination
          page={page}
          totalPages={totalElements}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setPage={setPage}
        />
    </Flex>
  );
};

export default WithAuth(Sellers);